import { Link } from 'react-router-dom';

interface TvCardProps {
  id: number;
  title: string;
  category: string;
  rating: number;
  episodes: number;
  year: number;
  status: string;
  coverUrl: string;
  tags: string[];
}

export default function TvCard({ id, title, category, rating, episodes, year, status, coverUrl, tags }: TvCardProps) {
  return (
    <Link to={`/article/${id}`} className="group block cursor-pointer">
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={coverUrl}
          alt={title}
          title={`${title} - ${category} ${year} ${episodes}集`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
        <div className="absolute top-3 left-3">
          <span className="px-2 py-1 text-xs font-semibold bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
            {rating}
          </span>
        </div>
        <div className="absolute top-3 right-3">
          <span className={`px-2 py-1 text-xs font-medium rounded-md whitespace-nowrap ${
            status === '更新中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-50/20 text-background-50 backdrop-blur-sm'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <h3 className="text-sm font-semibold text-white mb-1 line-clamp-1">{title}</h3>
          <div className="flex items-center gap-2 text-xs text-white/70 flex-wrap">
            <span>{category}</span>
            <span className="text-white/40">·</span>
            <span>{year}</span>
            <span className="text-white/40">·</span>
            <span>{episodes}集</span>
          </div>
        </div>
      </div>
    </Link>
  );
}